import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from "lottie-react";

import vayyar_guidelines from '../../assets/imgs/vayyar/guidelines.svg'; 
import vayyar01 from '../../assets/imgs/vayyar/vayyar01.png'; 
import vayyar02 from '../../assets/imgs/vayyar/vayyar02.png'; 
import vayyar03 from '../../assets/imgs/vayyar/vayyar00.png'; 

import vayyarAnimation01 from '../../assets/imgs/vayyar/vayyar01.json'; 
import vayyarAnimation02 from '../../assets/imgs/vayyar/animations/Guide1-Room Bath-1.json'; 
import vayyarAnimation03 from '../../assets/imgs/vayyar/animations/Guide1-Room Bath-2.json'; 
import vayyarAnimation04 from '../../assets/imgs/vayyar/animations/Guide1-Room Behind-1.json'; 
import vayyarAnimation05 from '../../assets/imgs/vayyar/animations/Guide1-Room Height.json'; 
import vayyarAnimation06 from '../../assets/imgs/vayyar/animations/Guide1-Room Scale-1.json'; 

import arrows from '../../assets/imgs/arrows/cover-img.png'; 


const VayyarPage = () => {



  return (
              
        <div className='bg-light'>
          <div className='header-height'></div>
                <div className='row'>
                <div className='col-sm-2 col-xs-none'></div>
                <div className='col-sm col-xs-12'>

                  <div className='row px-3 px-sm-5'>
                  <div className='col-md text-start mb-5 '>
                    <p className='fs-2 fw-normal lh-sm capitalize mb-2'>Vayyar Care Installation Guide</p>
                    <p className='fs-1rem fw-light capitalize'>
                    Interactive installation guide
                    </p>
                    <p className='mt-4 fw-light'>2021</p>

                  </div>
                  <div className='col-md'>
                    <p className='fw-normal fs-5'>
                      This project features a series of animations demonstrating the step-by-step installation process of Vayyar’s care device. Designed to enhance clarity and ease of use, the animations guide users through the device setup, ensuring efficient integration for fall detection and prevention.
                    </p>
                  </div>
    
                <div className='mb-sm-5'></div>
                  <Lottie animationData={vayyarAnimation01} loop={true} />
          </div>
        </div>



      <div className='row m-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12'></div>
          <div className='col-sm-6 col-xs-12 my-5 py-5'>
              <p className='fs-5 fw-normal'>
                The design process focused on user-centric principles, leveraging motion design to create clear, engaging, and informative animations. A minimalist visual approach was used to eliminate distractions, ensuring that key installation steps remained the focal point. Smooth transitions and precise pacing were implemented to enhance comprehension, while accessibility considerations guided color choices and contrast levels. Through iterative testing and refinements, the animations were optimized to deliver a seamless and intuitive user experience.
              </p>
        </div>
      </div>


      <div className='p-0 '>
          <img className='' src={vayyar_guidelines} width='100%'/>
      </div>


      <div className='row m-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12 my-5 py-5'>
            <p className='fs-5 fw-normal'>
            Animations were implemented as an essential component of the installation guidance to enhance usability, engagement, and cognitive load reduction. By leveraging motion design principles, the animations provide a seamless onboarding experience, ensuring users can efficiently set up the device with minimal friction. In ICT, dynamic visual aids improve information retention, as motion naturally directs the user’s attention to key actions, reinforcing intuitive interaction patterns.
                        </p>
          </div>
          <div className='col-sm-6 col-xs-12'>

        </div>
      </div>

      <div className='row g-4 m-0'>
      <div className='col-md col-xs-12'>
          <div className='mb-sm-5'></div>
          <Lottie animationData={vayyarAnimation02} loop={true} />
          <div className='mb-sm-5'></div>
          <Lottie animationData={vayyarAnimation03} loop={true} />
          <div className='mb-sm-5'></div>
          <Lottie animationData={vayyarAnimation04} loop={true} />
          <div className='mb-sm-5'></div>
          <Lottie animationData={vayyarAnimation05} loop={true} />
          <div className='mb-sm-5'></div>
          <Lottie animationData={vayyarAnimation06} loop={true} />
          <div className='mb-sm-5'></div>
        </div>
          <div className='col-md-3 col-xs-12'>

          </div>
        </div>

        <div className='row m-0 my-5 px-3 px-sm-5'>
        <div className='col-sm-6 col-xs-12 my-5 py-5'>
            <p className='fs-5 fw-normal'>
            Within an application ecosystem, animation is more than just an aesthetic enhancement—it serves as a functional UX/UI element that bridges the gap between the user and the system. Micro-interactions, guided transitions, and visual feedback contribute to a more immersive and responsive experience, reducing interface ambiguity and enhancing task efficiency. When used strategically, animations optimize the user flow, minimize errors, and improve overall human-computer interaction (HCI) by making complex processes more digestible.
                        </p>
                        <br></br>
                        <p className='fs-5 fw-normal'>
                        In the context of installation guidance, static text or images often lead to cognitive overload or misinterpretation, while animated instructions provide a real-time procedural walkthrough, ensuring clarity and ease of execution. Additionally, motion design plays a key role in brand perception and user engagement, making an application feel polished, modern, and reliable. As digital platforms continue to evolve, integrating animation into app design has become a best practice in UX/UI development, driving higher user satisfaction, retention, and overall product success.

                        </p>
          </div>
          <div className='col-sm-6 col-xs-12'>

        </div>
      </div>

      <div className='row g-4 p-5 m-0'>
      <div className='col-md col-xs-12'>
        </div>
          <div className='col-md-8 col-xs-12'>
          <div className='mb-sm-5'></div>
          <img className='py-2' src={vayyar01} width='100%'/>
          <div className='mb-sm-5'></div>
          <img className='py-2' src={vayyar02} width='100%'/>
          <div className='mb-sm-5'></div>
          <img className='py-2' src={vayyar03} width='100%'/>
          <div className='mb-sm-5'></div>
          </div>
        </div>

      </div>



<div className='row py-5 px-3 px-sm-5'>
<div className='col-sm-2 col-xs-12'></div>
<div className='col-sm col-xs-12'>

<div className='py-2'>
<Link to={"https://vayyar.com"}>
        <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
        <h5 className='fs-18 fw-600'>Client: Vayyar</h5>
        <div className='arrow-out'></div>
          </a>
            </Link>
</div>


    <div className='py-2'></div>
    <div className='d-block'>
      <h5 className=''>Credits:</h5>
      <ul className='p-0'>
      <li>App Development and UX Research: Netcraft</li>
      <li>Storyboard, Design and Animation: Paz Roth</li>
      </ul>

    </div>

    <div className='py-2'></div>


    <div className='row'>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Capabilities</h5>
          <ul className='p-0'>
            <li className='py-1'>Animation</li>
            <li className='py-1'>App Development</li>
            <li className='py-1'>Product Design</li>
            <li className='py-1'>UX/UI</li>
            <li className='py-1'>Design System</li>
          </ul>
      </div>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Softwares</h5>
          <ul className='p-0'>
            <li className='py-1'>Figma</li>
            <li className='py-1'>Illustrator</li>
            <li className='py-1'>After Effect</li>
            <li className='py-1'>Lottie Files</li>
          </ul>
      </div>
      
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Cooperation</h5>
          <ul className='p-0'>
            <li className='py-1'>Project</li>

          </ul>
      </div>

      <div className='col-sm col-xs-12'>
        <h5 className='fw-600'>Industry</h5>
            <li className='py-1'>technology Healthcare</li>
            <h5 className='fw-600 pt-2'>Duration</h5>
            <li className='py-1'>2 Months</li>
      </div>
    </div>
</div>
</div>

<div className='row mx-0 mt-3 mt-sm-5'>
  <div className='col-sm-12 col-xs-12 text-end p-5'>
      <Link to={"/arrows"}>
        <a className='fs-5 fw-bold text-dark'>
          Next work 
          <div className='arrow-right'></div>
          </a>
            </Link>
        </div>
        <div className='col-sm-2 col-xs-12 p-3 p-sm-5'>

        </div>
          <div className='col-sm col-xs-12 p-0'>
          <Link to={"/prodop"}>
            <div className='image-box-300'>
              <img src={arrows} alt="prodbo next" />
            </div>
          </Link>
        </div>
      </div>


</div>





  );
};

export default VayyarPage;
